module.exports = __webpack_public_path__ + "static/media/10.da5b20c9.jpg";